import React, { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { ClipLoader } from 'react-spinners';
import { Typography, makeStyles, useTheme } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    width: '100vw',
    marginTop: '-5rem',
  },
  title: {
    fontWeight: 'bold',
    fontSize: '1.5rem',
    marginBottom: '1rem',
  },
  formWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: '50%',
    margin: 'auto',
    '& > *': {
      margin: theme.spacing(2),
    },
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(3),
    },
  },
}));

export const LogoutRedirect: React.FC = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { removeUser } = useAuth();

  useEffect(() => {
    void removeUser().finally(() => {
      window.location.replace('/login');
    });
  }, [removeUser]);

  return (
    <div className={classes.container}>
      <Typography className={classes.title}>LOGGING OUT</Typography>
      <ClipLoader size={40} className="!border-purple-500 !border-4 !border-b-transparent mr-2" />
    </div>
  );
};

export default LogoutRedirect;
